import IconButton from '@anm/components/buttons/IconButton';
import { flexCenter, media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

const wrapperTablet = media.tablet`
  margin: 0 6px 20px;
  width: auto;
`;

export const Wrapper = styled(IconButton)<{ disabled?: boolean }>`
  padding: 0;
  min-width: 140px;
  min-height: 50px;
  margin-bottom: 20px;
  a {
    ${flexCenter};
    color: #fff;
    height: 100%;
  }
  &:before {
    opacity: 1;
  }
  ${({ disabled }) =>
    disabled &&
    css`
      background: var(--gray_50);
      &&:hover {
        background: var(--gray_50);
      }
    `}
  ${wrapperTablet};
`;
